module.exports = __webpack_public_path__ + "static/media/68-cayman.6b532870.JPG";